export type ContentViewerRole = 'user' | 'moderator' | 'admin';

type ManageContentArgs = {
  viewerId?: string | null;
  ownerId?: string | null;
  role?: ContentViewerRole | null;
};

export const isContentOwner = ({ viewerId, ownerId }: ManageContentArgs) =>
  Boolean(viewerId && ownerId && viewerId === ownerId);

export const isAdminViewer = ({ role }: ManageContentArgs) => role === 'admin';

export const isAdminModeratingOthersContent = (args: ManageContentArgs) =>
  isAdminViewer(args) && !isContentOwner(args);

export const canEditOwnedContentOnly = (args: ManageContentArgs) =>
  isContentOwner(args);

export const canRemoveKinfeedOrChannelContent = (args: ManageContentArgs) =>
  isContentOwner(args) || isAdminViewer(args);

export const canManageKinfeedOrChannelContent = canRemoveKinfeedOrChannelContent;

export const canManageOwnedContentOnly = (args: ManageContentArgs) =>
  isContentOwner(args);
